import React from 'react';

function SendingFailed() {
    return (
    <React.Fragment>
         <div className="sendingFailed">
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="22"
          height="22"><path fill="currentColor" 
          d="M12.008 16.52H9.992v-2.033h2.016v2.033zm0-4.472H9.992V5.48h2.016v6.568z"></path></svg>
             {/* <IconSendingFailedHoc/> */}
        </div>
        </React.Fragment>
    );
}

export default SendingFailed;
